/**
 * UUIDv7 for the `Idempotency-Key` header.
 *
 * The backend REQUIRES the header on every mutating route and validates that it parses as a UUID of
 * version 7 (`backend/internal/platform/idempotency/idempotency.go` — "Idempotency-Key must be a
 * UUID version 7"). A v4 is refused, so `crypto.randomUUID()` is not usable here.
 *
 * Layout (RFC 9562 §5.7): 48-bit big-endian Unix milliseconds, version 7, 12 bits of randomness,
 * variant 0b10, 62 bits of randomness.
 */
export function uuidv7(): string {
  const bytes = new Uint8Array(16);
  crypto.getRandomValues(bytes);

  const ms = Date.now();
  bytes[0] = (ms / 2 ** 40) & 0xff;
  bytes[1] = (ms / 2 ** 32) & 0xff;
  bytes[2] = (ms / 2 ** 24) & 0xff;
  bytes[3] = (ms / 2 ** 16) & 0xff;
  bytes[4] = (ms / 2 ** 8) & 0xff;
  bytes[5] = ms & 0xff;

  bytes[6] = 0x70 | ((bytes[6] ?? 0) & 0x0f);
  bytes[8] = 0x80 | ((bytes[8] ?? 0) & 0x3f);

  const hex: string[] = [];
  for (const b of bytes) hex.push(b.toString(16).padStart(2, '0'));
  return (
    `${hex.slice(0, 4).join('')}-${hex.slice(4, 6).join('')}-` +
    `${hex.slice(6, 8).join('')}-${hex.slice(8, 10).join('')}-${hex.slice(10, 16).join('')}`
  );
}
